import { useEffect } from 'react';
import * as React from 'react';
import { SanitizerService } from '../../../services/sanitizer.service';
import { ConfigurationService } from '../../../services/configuration.service';
import './style.scss';

function OverlayBox({
  statusText = undefined,
  headerText,
  contentText,
  contentTextCssClass = 'd-none d-sm-block',
  contentImageUrl = undefined,
  contentImageAltText = undefined,
  externalLinkText = undefined,
  externalLinkUrl = undefined,
  absolutePositionedMd = true,
  className = '',
  onExternalLinkClick = undefined,
  onLoad = undefined,
  children = undefined,
}: {
  statusText?: string;
  headerText: string;
  contentText: string;
  contentTextCssClass?: string;
  contentImageUrl?: string;
  contentImageAltText?: string;
  externalLinkText?: string;
  externalLinkUrl?: string;
  absolutePositionedMd?: boolean;
  className?: string;
  onExternalLinkClick?: () => void;
  onLoad?: () => void;
  children?: React.ReactNode;
}) {
  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  return (
    <div className={`overlay-component p-2 p-sm-3 bg-blue shadow ${absolutePositionedMd ? 'overlay-component--absolute' : 'shadow-md-none border-bottom-md'} ${className}`}>
      <h1 className={`${ConfigurationService.get('labs.micromobility.micromobilitysearchpage.headingvisuallyhidden') === 'true' ? 'visually-hidden' : 'text-wordbreak-break-word'}`}>{headerText}</h1>
      <div className={contentTextCssClass} dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(contentText) }}></div>
      {children}
      {statusText && <div className="mt-2">{statusText}</div>}
      {contentImageUrl && <img src={contentImageUrl} alt={contentImageAltText ?? ''} className={`d-none d-lg-block ${externalLinkText && externalLinkUrl ? 'mb-2' : ''}`} />}
      {externalLinkText && externalLinkUrl && (
        <a href={externalLinkUrl} className="d-none d-md-block text-end" target="_blank" onClick={onExternalLinkClick} rel="noreferrer">
          {externalLinkText}
        </a>
      )}
    </div>
  );
}

export default OverlayBox;
